import { authHeader, handleResponse } from './helper';
import config from '../config';


export const getActiveProvidersByBranches = async () => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
    },
  };

  const url = new URL(`${config.apiGeneralUrl}/providers/getActiveProvidersByBranches`);
  return await fetch(url, requestOptions).then(handleResponse);
};

export const setActiveProviders = (providers) => {
  localStorage.setItem('active_providers', JSON.stringify(providers));
};

export const getActiveProviders = () => {
  const value = localStorage.getItem('active_providers');
  try {
    return value ? JSON.parse(value) : null;
  } catch {
    return null;
  }
};
